<template>
  <div class="management-contract-details">
    <el-card>
      <div slot="header">签约人信息</div>
      <el-form :inline="true" label-suffix="：" :model="detail">
        <el-form-item label="姓名">{{detail.patName}}</el-form-item>
        <el-form-item label="性别">{{detail.patGender | sex(2)}}</el-form-item>
        <el-form-item label="年龄">{{detail.patAge}}</el-form-item>
        <el-form-item label="电话">{{detail.patMobile}}</el-form-item>
        <el-form-item label="身份证号">{{detail.patIdcard}}</el-form-item>
        <el-form-item label="地区">{{detail.areaName}}</el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <div slot="header">
        <el-row>签约信息</el-row>
        <el-row>已选服务：{{serveNameList}}</el-row>
        <el-row
          v-if="'WAITCONTRACT' !== detail.status"
        >申请签约日期：{{detail.createTime | timeFormat("%Y/%m/%d")}}</el-row>
        <el-row type="flex" justify="space-between">
          <span
            v-if="['CONTRACT', 'OVERDUE'].includes(detail.status)"
          >服务期限至：{{detail.endDate | timeFormat("%Y/%m/%d")}}</span>
          <span v-else-if="'CANCEL' === detail.status">取消理由：{{detail.cancelReason}}</span>
          <span v-else-if="'REFUSE' === detail.status">拒绝理由：{{detail.cancelReason}}</span>
          <span
            v-else-if="'WAITCONTRACT' === detail.status"
          >申请签约日期：{{detail.createTime | timeFormat("%Y/%m/%d")}}</span>
          <span>签约费用：{{parseFloat(detail.contractPrice / 100)}}元</span>
        </el-row>
      </div>
      <el-table :data="detail.serveList" style="width: 100%">
        <el-table-column prop="serveName" label="服务名称"></el-table-column>
        <el-table-column :formatter="formatServeNature" prop="serveNature" label="服务性质"></el-table-column>
        <el-table-column :formatter="formatServeWay" prop="serveWay" label="服务方式"></el-table-column>
        <el-table-column :formatter="formatServePrice" label="价格(元)"></el-table-column>
        <el-table-column :formatter="formatServeTotalNumber" prop="serveTotalNumber" label="总次数"></el-table-column>
        <el-table-column :formatter="formatOptional" prop="serveNature"></el-table-column>
      </el-table>
      <el-row
        class="management-contract-details__footer"
        type="flex"
        justify="center"
        v-if="detail.status === 'WAITCONTRACT'"
      >
        <el-button type="danger" @click="openRefuseDialog">拒绝签约</el-button>
        <el-button type="primary" @click="openContractDialog">确认签约</el-button>
      </el-row>
    </el-card>
    <el-dialog title="请输入拒绝原因" :visible.sync="refuseDialogVisible" width="30%">
      <el-input type="textarea" :rows="5" placeholder="拒绝原因" v-model="statementData.cancelReason"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="onRefuse">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
      custom-class="served-dialog"
      title="同意签约"
      :visible.sync="contractDialogVisible"
      width="30%"
    >
      <el-row type="flex" justify="center">
        <img src="../../../assets/icon/ok.png" alt>
      </el-row>
      <el-row
        class="served-dialog__desc"
      >本次签约总费用为{{parseFloat(detail.contractPrice / 100)}}元，服务期限为{{ servicePeriodStart }}至{{servicePeriodEnd}}。服务期限为一年。</el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contractDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="onContract">确定签约</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { timeFormat, sex } from "ty-vue-filters";
export default {
  data() {
    return {
      detail: {},
      servicePeriodStart: timeFormat(Date.now(), "%Y/%m/%d"),
      servicePeriodEnd: "",
      statementData: Object.create(null),
      refuseDialogVisible: false,
      contractDialogVisible: false
    };
  },
  filters: {
    sex,
    timeFormat
  },
  computed: {
    serveNameList() {
      const serveList = this.detail.serveList || [];
      return serveList.map(v => v.serveName).join("，");
    }
  },
  methods: {
    openRefuseDialog() {
      this.refuseDialogVisible = true;
      this.statementData = {
        status: "REFUSE",
        successMsg: "拒绝签约成功"
      };
    },
    openContractDialog() {
      this.contractDialogVisible = true;
      this.statementData = {
        status: "CONTRACT",
        successMsg: "确认签约成功"
      };
    },
    onRefuse() {
      if (!this.statementData.cancelReason) {
        this.$message.warning("请输入拒绝原因");
        return false;
      }
      this.handleServe(this.statementData);
      this.refuseDialogVisible = false;
    },
    onContract() {
      this.handleServe(this.statementData);
      this.contractDialogVisible = false;
    },
    handleServe({ successMsg, ...opts }) {
      axiosUtil(
        {
          ...opts,
          contractId: this.detail.id,
          service: "smarthos.contract.doc.status.update",
          token: localStorage.getItem("token")
        },
        ({ code, list, page, msg }) => {
          if (code === "0") {
            this.$message.success(successMsg);
            this.getDetails();
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    getDetails() {
      axiosUtil(
        {
          service: "smarthos.contract.doc.info",
          token: localStorage.getItem("token"),
          contractId: this.$route.query.id
        },
        ({ code, obj, msg }) => {
          if (code === "0") {
            this.detail = obj;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    formatServeTotalNumber(row, column, cellValue) {
      let result;
      if (row.serveTotalNumber === -1) {
        result = "不限";
      } else {
        result = row.serveTotalNumber;
      }
      return result;
    },
    formatServePrice(row, column, cellValue) {
      return parseFloat(row.servePrice / 100);
    },
    formatServeNature(row, column, cellValue) {
      const serveNatureObj = {
        BASE: "基础服务",
        EXTEND: "扩展服务"
      };
      const code = row.serveNature;
      return serveNatureObj[code];
    },
    formatServeWay(row, column, cellValue) {
      const serveWayObj = {
        ONLINE: "在线",
        DOOR: "上门服务",
        HOSPITAL: "到院服务"
      };
      return serveWayObj[row.serveWay];
    },
    formatOptional(row, column, cellValue) {
      const serveNatureObj = {
        BASE: "必选",
        EXTEND: "可选"
      };
      const code = row.serveNature;
      return serveNatureObj[code];
    },
    createServicePeriodEnd() {
      const now = new Date();
      const nowYear = now.getFullYear();
      const nowMonth = now.getMonth();
      const nowDate = now.getDate();
      this.servicePeriodEnd = timeFormat(
        new Date(nowYear + 1, nowMonth, nowDate - 1).getTime(),
        "%Y/%m/%d"
      );
    }
  },
  created() {
    this.createServicePeriodEnd();
    this.getDetails();
  }
};
</script>

<style lang="scss">
.management-contract-details {
  .el-form-item {
    width: 20%;
    min-width: 250px;
  }
  .el-row + .el-row {
    margin-top: 20px;
  }
  &__footer {
    margin-top: 25px;
  }
}
</style>